module.exports = __webpack_public_path__ + "static/img/pc-bg.96363e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/study/pc-bg.png
// module id = ptR/
// module chunks = 0